const AboutApp  = 
[{
  "name": "WB Exam Prep",
  "title": "WB Exam PYQ, Practics Questions, Mock Test",
  "link": "https://play.google.com/store/apps/details?id=com.mystudyplace.westbengalexam",
  "symbol": "./../../logo.png",
  "supportEmail": "support@mystudyplace.in",
  "address": "Suti, Murshidabad, WestBangal, India, 742201"
  
}
]




export default  AboutApp;